import { createHttpClient, type ClientConfig } from "./client";
import { createApi } from "./endpoints";

export * from "./errors";
export * from "./pagination";
export type * from "./operations";
export * from "./token-store";
export type * from "./types";
export type { Api } from "./endpoints";
export type { VisitFilter } from "./endpoints-guests";
export type { LodgingAvailabilityQuery, LodgingJonasOutcome, LodgingJonasReportQuery, LodgingStayFilter, LodgingTabletApi, LodgingUnitFilter } from "./endpoints-lodging";
export { createLodgingTabletApi } from "./endpoints-lodging";
export type { DiningReservationFilter, EventsListFilter } from "./endpoints-events";
export type { AccessFilter } from "./endpoints-portal";
export type { NotificationOutboxFilter } from "./endpoints-notifications";
export type { CommsLogFilters, CommsMessageFilters } from "./endpoints-communications";
export type { DocumentOwnerFilter } from "./endpoints-documents";
export type { PosItemFilters } from "./endpoints-pos";
export type { WordingFilters } from "./endpoints-wording";
export { createMemberApi, newIdempotencyKey } from "./endpoints-member";
export { createMobileClient } from "./mobile-client";
export type { MobileClient } from "./mobile-client";
export type { MemberApi } from "./endpoints-member";
export type { ClientConfig, Download, HttpClient, RequestOptions } from "./client";
export { createHttpClient } from "./client";
export { createApi } from "./endpoints";
export type { components, paths } from "./generated/schema";

/** One-call setup: an HTTP client plus the typed endpoint methods. */
export function createClubCoreClient(config: ClientConfig) {
  return createApi(createHttpClient(config));
}
